import { deleteRequest } from '@/core';
import { savedOrderSearches } from '@/requests';

export default async function deleteSavedOrderSearchRequest(id) {
	let url = savedOrderSearches.getByIdPath(id);
	let response = await deleteRequest(url);
	return response;
}
